<form [formGroup]="form" (ngSubmit)="$event.preventDefault()">
  <div class="checkbox-section">
    <app-yes-no-checkbox
      [label]="'injuries.presence'"
      [value]="getPresenzaFeriti()"
      [required]="true"
      (valueChange)="setPresenzaFeriti($event)">
    </app-yes-no-checkbox>

    <app-yes-no-checkbox
      [label]="'damage.material.beyond.vehicles'"
      [value]="getDanniMateriali()"
      [required]="true"
      (valueChange)="setDanniMateriali($event)">
    </app-yes-no-checkbox>

    <app-yes-no-checkbox
      [label]="'witnesses.presence'"
      [value]="getPresenzaTestimoni()"
      [required]="true"
      (valueChange)="setPresenzaTestimoni($event)">
    </app-yes-no-checkbox>
  </div>

  @if (getPresenzaTestimoni() === 'true') {
    <div class="witnesses-section">
      <mat-card class="witnesses-card">
        <mat-card-header>
          <mat-card-title>
            <mat-icon>people</mat-icon>
            {{ 'witnesses.title' | translate }}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          @for (witness of witnesses; track $index; let i = $index) {
          <div class="witness-row">
            <div class="witness-fields">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'field.nome' | translate }} *</mat-label>
                <input matInput [(ngModel)]="witness.nome" [ngModelOptions]="{standalone: true}" (ngModelChange)="triggerValidation()">
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'field.cognome' | translate }} *</mat-label>
                <input matInput [(ngModel)]="witness.cognome" [ngModelOptions]="{standalone: true}" (ngModelChange)="triggerValidation()">
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'field.email' | translate }} *</mat-label>
                <input matInput type="email" [(ngModel)]="witness.email" [ngModelOptions]="{standalone: true}" (blur)="onEmailBlur(i)">
                @if (witness.email && !isEmailValid(i)) {
                  <mat-error>Email non valida</mat-error>
                }
              </mat-form-field>

              <app-international-phone-input
                [(ngModel)]="witness.telefono"
                [ngModelOptions]="{standalone: true}"
                (ngModelChange)="triggerValidation()"
                (validationChange)="onPhoneValidation(i, $event)"
                [hasError]="!isPhoneValid(i)">
              </app-international-phone-input>
            </div>

            <app-textarea-counter
              [label]="'witnesses.statement' | translate"
              [maxLength]="1000"
              [rows]="3"
              [(ngModel)]="witness.dichiarazione"
              [ngModelOptions]="{standalone: true}"
              (ngModelChange)="triggerValidation()">
            </app-textarea-counter>

            @if (witness.email && !isEmailValid(i)) {
              <div class="phone-error-message">
                <mat-icon class="error-icon">error</mat-icon>
                <span>Inserire un indirizzo email valido</span>
              </div>
            }
            <div class="witness-actions">
              @if (i === witnesses.length - 1 && isWitnessValid(witness) && isPhoneValid(i) && isEmailValid(i)) {
                <button mat-icon-button type="button" color="primary" (click)="addWitness()" matTooltip="Add another witness">
                  <mat-icon>add</mat-icon>
                </button>
              }
              @if (witnesses.length > 1 || !isWitnessEmpty(witness)) {
                <button mat-icon-button type="button" color="warn" (click)="removeWitness(i)" matTooltip="Remove witness">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </div>
          </div>
          }
        </mat-card-content>
      </mat-card>
    </div>
  }

  <div class="form-group description-section">
    <app-textarea-counter
      [label]="'damage.description' | translate"
      [placeholder]="'placeholder.damage' | translate"
      [maxLength]="2000"
      [rows]="4"
      formControlName="descrizioneDanni">
      @if (form.get('descrizioneDanni')?.hasError('required') && form.get('descrizioneDanni')?.touched) {
        <mat-error>{{ 'required.damage_required' | translate }}</mat-error>
      }
      @if (form.get('descrizioneDanni')?.hasError('minlength') && form.get('descrizioneDanni')?.touched) {
        <mat-error>{{ 'required.damage_lenght' | translate }}</mat-error>
      }
    </app-textarea-counter>
  </div>
</form>
